
import React from 'react'
import { Resource } from 'react-admin';

// import Regions from '../region'
import AccountTeam from './account_team'
import AccountHandler from './account_handler'
// import ItemPriorityGroups from './priority_item_groups'
import PriorityLevel from './priority_level'
// import ItemMarketCategories from './market_categories'
import ItemMarketHierarchy from './in_market_hierarchy'
// import SalesHandlerMappingCreate from './sales_handlers/SalesHandlerMappingCreate'
// import SalesTeamMappingCreate from './sales_teams/SalesTeamMappingCreate'
// import KelloggsChainMappingCreate from './CreateKelloggsChainMapping'
// import KelloggsChainMappingEdit from './EditKelloggsChainMapping'
import Broker from './broker'
// import BrokerMappingCreate from './broker/CreateMappingButton'
// import MasterChainEdit from './master_chain'
// import MasterChainEditComponent from './MasterChainEdit'

const CLIENT_ONLY_RESOURCES = [
    
    
    <Resource name='kelloggs_chain_to_chain_mapping'
        //  create={KelloggsChainMappingCreate} 
        //  edit={KelloggsChainMappingEdit}
         />,
    // <Resource name='kelloggs_account_team_chain_mapping' create={SalesTeamMappingCreate}/>,
    <Resource {...AccountHandler}/>,
    <Resource name='kelloggs_account_handler_chain_mapping' 
        // create={SalesHandlerMappingCreate}
        />,
    <Resource name='kelloggs_account_handler_warehouse_mapping' />,

    <Resource {...AccountTeam}/>,
    <Resource name='kelloggs_account_team_chain_mapping' 
        // create={SalesHandlerMappingCreate}
        />,
    <Resource name='kelloggs_account_team_warehouse_mapping' />,
    
    <Resource {...PriorityLevel}/>,
    // <Resource {...ItemMarketCategories}/>,
    <Resource {...ItemMarketHierarchy } />,
    <Resource {...Broker} />,
    <Resource name='kelloggs_broker_chain_mapping' 
        // create={BrokerMappingCreate}
        />,
    <Resource name='kelloggs_broker_warehouse_mapping' 
        // create={BrokerMappingCreate}
        />,
    <Resource name='kelloggs_in_market_hierarchy_mapping'/>,

    // <Resource name='kelloggs_in_market_category' />,
    // <Resource name="kelloggs_priority_level" />
]

export default CLIENT_ONLY_RESOURCES;
